import axios from '@/utils/axios'
import {getAuthorizationByRole, getBackendByRole} from '@/utils/role'

/**
 * 刷新Token
 */
export const refreshToken = params => {
  return axios({
    url: `${getBackendByRole()}/user/refreshToken`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    transformRequest: [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }
    ],
    data: params
  })
}

/**
 * app扫码登录-获取二维码
 */
export const getSCLoginCode = params => {
  return axios({
    url: `${getBackendByRole()}/user/pc_session`,
    headers: {
      'Authorization': getAuthorizationByRole()
    },
    method: 'post',
    params: params
  })
}

/**
 * app扫码后确认
 */
export const sCLogin = params => {
  return axios({
    url: `${getBackendByRole()}/user/session_login`,
    headers: {
      'Authorization': getAuthorizationByRole()
    },
    method: 'post',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/common/login.js